import { createApp } from 'vue';

import Quasar from 'quasar/src/vue-plugin.js';;
import Plugin from '@quasar/quasar-ui-qcalendar/src/QCalendarDay.js';
import router from './plugins/router';
import '@quasar/quasar-ui-qcalendar/src/css/calendar-day.sass';

// axios
import axios from 'axios';
import VueAxios from 'vue-axios';

import * as auth from './plugins/auth'
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    auth.clearAuthentication();
    router.push('login')
  }
  return error;
});

axios.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + auth.getToken();
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// moment
import moment from 'moment'
moment.locale('tr')

// event bus
import mitt from 'mitt';
import App from './App.vue';

import quasarUserOptions from './quasar-user-options';

axios.defaults.baseURL = "https://diyetisyengizemeti.com:8888";

const emitter = mitt();

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(router)
  .use(Plugin)
  .use(VueAxios, axios)
  .provide('emitter', emitter)
  .mount('#app');
